import type { ReactNode } from "react";
import { usePostHogPageview } from "~components/shared/postHog/usePostHogPageview.ts";
import { RunningTimeTrackingBanner } from "~components/TimeManagement/RunningTimeTrackingBanner/RunningTimeTrackingBanner";
import { useMarkFirstPaint } from "~lib/firstPaint.ts";

import { Header } from "./Header/Header";
import styles from "./Layout.module.scss";
import { Sidebar } from "./Sidebar/Sidebar.tsx";

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  usePostHogPageview();
  useMarkFirstPaint();

  return (
    <div className={styles.container}>
      <div>
        <RunningTimeTrackingBanner />
      </div>
      <div className={styles.base}>
        <nav className={styles.nav}>{<Sidebar />}</nav>
        <header className={styles.header}>{<Header />}</header>
        <main className={styles.main}>{children}</main>
      </div>
    </div>
  );
}
